var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('solution-selector',{attrs:{"solutionid":_vm.$root._data.solutionid,"storename":_vm.$root._data.storename == 'true' ? true : false,"validation":_vm.$root._data.validation,"errorMessage":_vm.$root._data.errorMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }